import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/internal-tools/qrcode',
    exact: true,
    page: getLoadablePage(() => import(/* webpackChunkName: "internal_tools_qr_code" */ '../pages/qrcode')),
    chunkName: 'internal_tools_qr_code',
  },
];
